import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MyClientsReSignRequestModel } from '../models/myClientsReSignRequest.model';
import { MyClientsReSingRespondeModel } from '../models/myClientsReSingResponse.model';
import { Observable } from 'rxjs';
import { MyClientsReSignEmailFauRequestModel, MyClientsReSignEmailFauResponse } from '../models/myClientsReSingEmailRequest.model';
import { environment } from '../../environments/environment';
import { TransactionService } from "@services/transaction.service";
import { catchError, tap } from 'rxjs/operators';
import { LogRequestModel } from '@app/models/logs.model';

@Injectable({
  providedIn: 'root'
})
export class MyClientsService {
  private url: string;
  private urlSendEmail: string;
  public token: string = '';
  
  constructor(
    private http: HttpClient,
    private transactionService: TransactionService
  ) { 
    this.url = environment.urlApi;
    this.urlSendEmail = `${environment.urlApiDev}/buyerint`;
  }

  getClientData(params: MyClientsReSignRequestModel) : Observable<MyClientsReSingRespondeModel> {
    const headers: HttpHeaders = new HttpHeaders({
      'token':  this.getTokenAlt() || '' 
    });

    const options = {
      headers,
      params: params as any
    };
    
    return this.http.get<MyClientsReSingRespondeModel>(`${this.url}/pr_comprador_firma_fau`, options);
  }

  sendEmailReSignFau(params: MyClientsReSignEmailFauRequestModel): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Basic ' + btoa(environment.buyerIntApiKey)
    });

    return this.http.post<MyClientsReSignEmailFauResponse>(`${this.urlSendEmail}/validar_otp/correoCompradorRefirmaFirmaDigital`, params, { headers })
      .pipe(
        tap((response: MyClientsReSignEmailFauResponse) => {
          this.saveLogRequestFromReSignFau(params, String(response.status), response);
        }),
        catchError((error: any) => {
          this.saveLogRequestFromReSignFau(params, error['status'] || '400', error);
          throw error;
        })
      );
  }

  saveLogRequestFromReSignFau(params: MyClientsReSignEmailFauRequestModel, status: string, data: string | Object): void {
    const request: LogRequestModel = this.buildLogRequestFromReSignFau(params, status, data);
    this.transactionService.setSignatureTypeLog(request).subscribe();
  }

  buildLogRequestFromReSignFau(params: MyClientsReSignEmailFauRequestModel, status: string, data: string | Object): LogRequestModel {
    const { id, usuario, firmaPagare } = params;
    const stringifyData = typeof data == 'object' ? JSON.stringify(data) : data;
    const requestLog: LogRequestModel = {
      paso: `paso_0_mis_clientes_${firmaPagare ? '+_pagare' : '_sin_pagare'}`,
      usuario: usuario,
      id: id,
      status: status,
      respuesta: stringifyData
    }
    return requestLog;
  }

  getTokenAlt() {
    const token = sessionStorage.getItem('tokenALT');
    if ( token ) {
      return token;
    }
  }

}
